import React, { useEffect, useState } from "react";
import "../../../css/WeekTransSubsc.css";
import { fetchAsyncSubscPerDay, SubscPerDay } from "../SubscriberSlice";
import { handleDate, selectedDate } from "../../weather/WeatherSlice";
import {
  Tooltip,
  XAxis,
  CartesianGrid,
  Legend,
  YAxis,
  ResponsiveContainer,
  LineChart,
  Line,
} from "recharts";
import { useDispatch, useSelector } from "react-redux";

interface WeekTransSubscProps {
  page: number;
  handlePage: (item: number) => void;
}

const WeekTransSubsc = ({ page, handlePage }: WeekTransSubscProps) => {
  const dispatch = useDispatch();
  const SubscPerDayData = useSelector(SubscPerDay);

  //データ更新い
  useEffect(() => {
    // 初回描画時に実行する処理
    dispatch(fetchAsyncSubscPerDay(page));

    // 定期実行を設定
    const interval = setInterval(() => {
      dispatch(fetchAsyncSubscPerDay(page));
    }, 60000); // 60秒ごとに実行

    // コンポーネントのクリーンアップ時にインターバルをクリア
    return () => clearInterval(interval);
  }, [dispatch, page]);

  //tooltipをカスタムして天気と連動
  const CustomTooltip = ({ active, payload }: any) => {
    if (active && payload && payload.length) {
      const data = payload[0].payload; // payloadからデータを取得

      // 親コンポーネントのstate更新関数を呼び出し
      dispatch(handleDate(data.week));

      return (
        <div className="tooltip">
          <p className="date">{data.week}</p>
          <p className="subsc">登録者数 : {data.subsc}</p>
          <p className="auth">認証終了者数 : {data.auth}</p>
        </div>
      );
    }

    return null;
  };

  return (
    <div
      className="week_subsc_trans_container"
      onMouseOut={() => dispatch(handleDate(null))}>
      <div className="week_subsc_title_container">
        <div className="back" onClick={() => handlePage(1)}>
          ←
        </div>
        <h2 className="week_subsc_trans_title">登録者数推移(7日間ごと)</h2>
        <div className="next" onClick={() => handlePage(-1)}>
          →
        </div>
      </div>
      <ResponsiveContainer
        height="75%"
        width="90%"
        minHeight={240}
        minWidth={300}>
        <LineChart data={SubscPerDayData!} className="line_chart">
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="week" />
          <YAxis dataKey="subsc" />
          <YAxis dataKey="auth" />
          <Tooltip content={<CustomTooltip />} />
          <Legend />
          <Line
            type="monotone"
            dataKey="subsc"
            stroke="#82ca9d"
            name="登録者数"
          />
          <Line
            type="monotone"
            dataKey="auth"
            stroke="#8884d8"
            name="認証終了者数"
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default WeekTransSubsc;
